export const PSYLARIS_BLUE = 'RGBA(34,146,186,1)'; //'0x2292ba';
export const PSYLARIS_ORANGE = 'RGBA(255,80,27,1)'; //'0xff501b';
export const PSYLARIS_LIGHTER_GREY = 'RGBA(224,224,224,1)'; //0xe0e0e0;
export const PSYLARIS_SLIGHTLY_LIGHTER_GREY = 'RGBA(230,230,230,1)';
export const PSYLARIS_LIGHT_GREY = 'RGBA(237,237,237,1)'; //0xededed;
export const PSYLARIS_GREY = 'RGBA(49,55,53,1)'; // #313735
export const PSYLARIS_DARK = 'RGBA(49,55,53,1)'; //313735
